import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Blueprint } from '@/components/ui/Blueprint';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ptBR } from '@/i18n/pt-BR';

export function ForbiddenPage() {
  const t = ptBR.errorPages.forbidden;
  return (
    <section
      data-testid="forbidden-page"
      aria-labelledby="forbidden-title"
      className="mx-auto max-w-2xl py-16"
    >
      <Blueprint className="px-8 py-10">
        <p
          data-testid="forbidden-code"
          className="mb-2 text-center font-mono text-caption uppercase tracking-[0.02em] text-fg-dim"
        >
          {t.code}
        </p>
        <EmptyState
          icon={ShieldAlert}
          title={t.title}
          description={t.body}
          action={
            <Button asChild variant="primary" size="default">
              <Link to="/" data-testid="forbidden-back-cta">
                {t.backCta}
              </Link>
            </Button>
          }
          aria-labelledby="forbidden-title"
          className="border-0 p-0"
        />
      </Blueprint>
      <h1 id="forbidden-title" className="sr-only">
        {t.title}
      </h1>
    </section>
  );
}
